module.exports = __webpack_public_path__ + "img/resultSub.d4535f4.png";